<ng-container *transloco="let t; read: 'building.technicalInstallation'">
  <div mat-dialog-title class="title-container">
    <h2>{{ t(editionMode ? 'editAnnounceFile' : 'addAnnounceFile') }}</h2>
  </div>

  <mat-dialog-content>
    <div [formGroup]="announcementForm">
      <div>
        <label>{{ t('installationTypeLabel') }} {{ announcementForm | requiredIndicator : 'installationType' }}</label>
        <p>
          <mat-form-field>
            <mat-select formControlName="installationType">
              @for (type of installationTypes; track type) {
              <mat-option [value]="type">
                {{ t('installationType', {type}) }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </p>
      </div>

      <div>
        <label>{{ t('designation') }}</label>
        <p>
          <mat-form-field>
            <input matInput formControlName="designation" />
          </mat-form-field>
        </p>
      </div>

      <div>
        <label>
          {{ t('installationDate') }}
          {{ announcementForm | requiredIndicator : 'installationDate' }}
        </label>
        <p>
          <mat-form-field appearance="fill">
            <input
              matInput
              [matDatepicker]="picker1"
              formControlName="installationDate"
              placeholder="Choisir une date"
              [readonly]="true"
              [disabled]="editionMode"
            />
            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
            <mat-error>{{ 'errors.requiredField' | transloco }}</mat-error>
          </mat-form-field>
        </p>
      </div>

      <div>
        <label>{{ t('lastControlDate') }} {{ announcementForm | requiredIndicator : 'lastControlDate' }}</label>
        <p>
          <mat-form-field appearance="fill">
            <input matInput [matDatepicker]="picker" formControlName="lastControlDate" placeholder="Choisir une date" />
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
        </p>
      </div>

      <div>
        <label>{{ t('requirementLabel') }} {{ announcementForm | requiredIndicator : 'necessity' }}</label>
        <p class="radio-field">
          <mat-radio-group formControlName="necessity" [attr.aria-label]="t('requirementLabel')">
            @for (necessity of necessities; track necessity) {
            <mat-radio-button [value]="necessity"> {{ t('requirementType', { type: necessity }) }}</mat-radio-button>
            }
          </mat-radio-group>
        </p>
      </div>
      <div>
        <label>{{ t('emplacement') }} {{ announcementForm | requiredIndicator : 'location' }}</label>
        <p>
          <mat-form-field>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="10"
              formControlName="location"
              (keyup)="extendTextArea($event.target)"
            >
            </textarea>
          </mat-form-field>
        </p>
      </div>

      <div>
        <label>{{ t('remarks') }} {{ announcementForm | requiredIndicator : 'remarks' }}</label>
        <p>
          <mat-form-field>
            <textarea
              matInput
              cdkTextareaAutosize
              cdkAutosizeMinRows="1"
              cdkAutosizeMaxRows="10"
              formControlName="remarks"
              (keyup)="extendTextArea($event.target)"
            >
            </textarea>
          </mat-form-field>
        </p>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <sibat-validate-button
      class="mat-button-base"
      (clicked)="validate()"
      [disabled]="!announcementForm.valid"
      [label]="'building.documents.validate' | transloco"
    >
    </sibat-validate-button>

    <sibat-secondary-button class="mat-button-base" (clicked)="cancel()" [label]="'building.documents.cancel' | transloco">
    </sibat-secondary-button>
  </mat-dialog-actions>
</ng-container>
